import React from "react";
// UI Framework
import { toast } from "react-toastify";
// Common Component
import { DynamicDropdown, Button, TextInput, Form } from "src/Components";
// Request
import {
  getCallOption,
  getCallOptionData,
  submit,
} from "src/Requests/iMEMarketWatch";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import type { ICalculatorParams } from "src/Interfaces/iMEMarketWatch";

interface IProps {
  onClose: () => void;
}
const Calculator: React.FC<IProps> = () => {
  const [loading, setLoading] = React.useState(false);
  const [contractCode, setContractCode] = React.useState();
  const [searchParam, setSearchParam] = React.useState<ICalculatorParams>(
    {} as ICalculatorParams,
  );

  React.useEffect(() => {
    if (contractCode) {
      getCallOptionData(contractCode).then((res) => {
        setSearchParam(res.data);
      });
    }
  }, [contractCode]);

  const searchParamChangeHandler = (name: string, value: any) => {
    setSearchParam({
      ...searchParam,
      [name]: value,
    });
  };

  const onSubmit = () => {
    submit({
      underlyingAssetPrice: searchParam?.underlyingAssetPrice,
      callStrikePrice: searchParam?.callStrikePrice,
      callDTM: searchParam?.callDTM,
      hpr: searchParam?.hpr,
      annualCompoundedProfitPercent: searchParam?.annualCompoundedProfitPercent,
      buyUnderlyingAssetFee: searchParam?.buyUnderlyingAssetFee,
      sellCallFee: searchParam?.sellCallFee,
      sellCallSettlementFee: searchParam?.sellCallSettlementFee,
      callPrice: searchParam?.callPrice,
    } as ICalculatorParams)
      .then((res) => {
        if (!res.data) {
          toast.error(res.msg);
          return;
        }
        setSearchParam({ ...res.data });
        toast.success(res.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <div>
        <Form className="p-6 gap-6">
          <div className="flex justify-between items-end w-full gap-6">
            <DynamicDropdown
              dropdown={{
                name: "contractCode",
                placeholder: "نماد کال",
                extraLabel: true,
              }}
              getData={getCallOption}
              onChange={(_: string, value: any) => setContractCode(value)}
              value={contractCode}
            />
            <TextInput
              name="callStrikePrice"
              label="اعمال کال"
              extraLabel
              onChange={searchParamChangeHandler}
              value={searchParam?.callStrikePrice?.toString() || ""}
              kind="price"
              disabled
            />
            <TextInput
              name="callDTM"
              label="روز تا سررسید کال"
              extraLabel
              onChange={searchParamChangeHandler}
              value={Math.trunc(searchParam?.callDTM ?? 0)?.toString()}
              disabled
            />
          </div>
          <div className="flex flex-col gap-2">
            <TextInput
              name="underlyingAssetPrice"
              label="قیمت دارایی پایه"
              extraLabel
              onChange={searchParamChangeHandler}
              value={searchParam?.underlyingAssetPrice?.toString() || ""}
              kind="price"
            />
            <TextInput
              name="callPrice"
              label="قیمت کال"
              extraLabel
              onChange={searchParamChangeHandler}
              value={searchParam?.callPrice?.toString() || ""}
              kind="price"
            />
            <TextInput
              name="annualCompoundedProfitPercent"
              label="بازده مرکب سالانه %"
              extraLabel
              onChange={searchParamChangeHandler}
              value={searchParam?.annualCompoundedProfitPercent}
              kind="negativeDecimalNumbers"
            />
            <TextInput
              name="hpr"
              label="بازده دوره %"
              extraLabel
              onChange={searchParamChangeHandler}
              value={
                searchParam.hpr
                  ? (
                      Math.floor(Number(searchParam?.hpr) * 100) / 100
                    ).toString()
                  : ""
              }
              disabled
              kind="negativeDecimalNumbers"
            />
            <TextInput
              name="dailyReturn"
              label="بازده روزانه %"
              extraLabel
              onChange={searchParamChangeHandler}
              value={searchParam.dailyReturn ?? ""}
              kind="percent"
              disabled
            />
          </div>
          <div className="w-28 self-end">
            <Button
              onClick={onSubmit}
              text="ثبت"
              variant="contained"
              loading={loading}
            />
          </div>
        </Form>
      </div>
      {/* {Table} */}
    </div>
  );
};

export default Calculator;
